const url = window.__img_url__ || 'http://pic.cre-power.com/HF/CEIBS/fmba/'
const mapping = {
    loading: url + 'loading.gif',
    phoneIcon: url + 'icon_phone.png', // 电话图标
    applyIcon: url + 'icon_apply.png', // 申请图标
    contact: url + 'contact_01.jpg', // 联系我们中的背景图
    apply: url + 'apply_01.jpg', // 申请流程中的背景图
    flow: url + 'apply_02.png', // 申请流程中的流程图
    flow2: url + 'apply_03.png', // 申请路程中的报名路程图
    activity: url + 'events_01.png', // 近期活动的标题图片
    activityPic: url + 'events_pic_01.jpg', // 近期活动的示例图片
    student: url + 'student_01.jpg', // 学生构成的图片
    summary: url + 'Features_01.jpg', // FMBA一览的图片
    home: url + 'home_01.jpg', // 顶部大图
    logo: url + 'logo_CEIBSMBA.png',
    iconHome: url + 'icon_home.png',
    slogan01: url + 'home_slogan_01.png',
    slogan02: url + 'home_slogan_02.png',
    homeIcon01: url + 'home_icon_01.png',
    homeIcon02: url + 'home_icon_02.png',
    homeIcon03: url + 'home_icon_03.png',
    homeIcon04: url + 'home_icon_04.png',
    homeIcon05: url + 'home_icon_05.png',
    homeIcon06: url + 'home_icon_06.png',
    navigator01: url + 'home_icon_07.png',
    navigator02: url + 'home_icon_08.png',
    navigator03: url + 'home_icon_09.png',
    navigator04: url + 'home_icon_10.png',
    navigator05: url + 'home_icon_11.png',
    navigator06: url + 'home_icon_12.png',
    navigatorActive01: url + 'home_icon_13.png',
    navigatorActive02: url + 'home_icon_14.png',
    navigatorActive03: url + 'home_icon_15.png',
    navigatorActive04: url + 'home_icon_16.png',
    navigatorActive05: url + 'home_icon_17.png',
    navigatorActive06: url + 'home_icon_18.png',
    course: url + 'programme_01.jpg',
    courseTitle01: url + 'programme_02.png',
    courseTitle02: url + 'programme_04.png',
    courseTitle03: url + 'programme_06.png',
    courseTitle04: url + 'programme_08.png',
    courseTitle05: url + 'programme_12.png',
    courseContent01: url + 'programme_03.png',
    courseContent02: url + 'programme_05.png',
    courseContent03: url + 'programme_07.png',
    courseContent04: url + 'programme_09.png',
    courseContent05: url + 'programme_13.png',
    left: url + 'icon_left.png',
    right: url + 'icon_right.png',
    up: url + 'programme_10.png',
    down: url + 'programme_11.png',
    top: url + 'contact_02.png',
    student01: url + 'student_word_01.png',
    student02: url + 'student_word_02.png',
    student03: url + 'student_word_03.png',
    student04: url + 'student_word_04.png',
    student05: url + 'student_word_05.png',
    student06: url + 'student_word_06.png',
    student07: url + 'student_word_07.png',
    form: url + 'form_01.jpg'
};

// 加工一下
// for(let key in mapping) {
//     mapping[key] = mapping[key] + '?t=' + Date.now();
// }

export default mapping;
